import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import Cart from "./pages/Cart";
import { CartProvider } from "./Context/CartContext";
import { PincodeProvider } from "./Context/PincodeContext";
import { RecentlyViewedProvider } from "./Context/RecentlyViewedContext";
import { WishlistProvider } from "./Context/WishlistContext";
import WIP from "./pages/WIP";

import Home from "./pages/Home";
import Shop from "./pages/Shop";
import ProductDetail from "./pages/ProductDetail";
import Wishlist from "./pages/Wishlist";
import About from "./pages/About";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import Checkout from "./pages/Checkout";
import Orders from "./pages/Orders";
import AdminAddProduct from "./pages/AdminAddProduct";

export default function App() {
  return (
    <BrowserRouter>
      <PincodeProvider>
        <RecentlyViewedProvider>
          <WishlistProvider>
            <CartProvider>
              <Header />

              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/shop" element={<Shop />} />
                <Route path="/product/:id" element={<ProductDetail />} />
                <Route path="/cart" element={<Cart />} />
                <Route path="/wishlist" element={<Wishlist />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<Terms />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/profile/orders" element={<Orders />} />
                <Route
                  path="/admin/add-product"
                  element={<AdminAddProduct />}
                />
              </Routes>

              <Footer />
            </CartProvider>
          </WishlistProvider>
        </RecentlyViewedProvider>
      </PincodeProvider>
    </BrowserRouter>
  );
}
